import lodash from 'lodash'
import React, { ReactElement, useMemo } from 'react'
import styled from 'styled-components'

import Field, {
  useField,
} from '../../../../../../../../1stlog-ui/src/components/Field'
import useFieldRaw from '../../../../../../../../1stlog-ui/src/components/Field/useFieldRaw'
import Icon from '../../../../../../../../1stlog-ui/src/components/Icon'
import RadioSelect from '../../../../../../../../1stlog-ui/src/components/RadioSelect'
import useOrderEntry from '../../../../../useOrderEntry'
import useTransport from '../../../useTransport'
import TimeHandler from './TimeHandler'
import TimeSettings from './TimeSettings'

const Wrapper = styled.div``

function validateTime(value: number | string): string | undefined {
  return !value || value === '' || value === 0 ? 'fail' : undefined
}

export type TTimeBlockProps = {
  product: any
  isPickup: boolean
  isPickupProduct: boolean
}

const TimeBlock = (props: TTimeBlockProps): ReactElement => {
  const { product, isPickup, isPickupProduct } = props

  const { isInternal } = useOrderEntry()

  const {
    // defaultTime,
    pickupType,
    deliveryType,
    pickupFromTime,
    deliveryFromTime,
    isSelfPickup,
    isSelfDelivery,
  } = product || {}

  // console.log("timeOptions", timeOptions)

  const { isMixedTransport } = useTransport()

  const {
    input: { value: selectedTime, onChange: setSelectedTime },
    meta: { error },
  } = useFieldRaw('selectedTime', {
    validate: validateTime,
    subscribeAll: true,
  })
  const [settings, setSettings] = useField('settings', { asState: true })

  const timeOptions = useMemo(() => {
    const result = [
      isMixedTransport || isPickupProduct === isPickup || !isInternal
        ? undefined
        : {
            id: 'ownArea',
            name: `${isPickup ? 'Abholung' : 'Zustellung'} in eigenem Gebiet`,
          },
      ...lodash.filter(product.timeOptions, (t) => {
        if (t.isPickup && isPickup) {
          return true
        }
        if (t.isDelivery && !isPickup) {
          return true
        }
        return false
      }),
    ].filter(Boolean)
    return result
  }, [product, isMixedTransport, isPickup, isPickupProduct])

  // console.log('timeOptions', { timeOptions: product.timeOptions, isPickup })

  const onChangeOption = (o): void => {
    setTimeout(() => setSelectedTime(o), 0)
  }

  const options = lodash.map(timeOptions, (option) => {
    const { id, name, type, requiresConfirmation, from, until } = option
    const description = (
      <TimeSettings
        {...option}
        isPickup={isPickup}
        timeOptions={timeOptions}
        onChangeOption={onChangeOption}
      />
    )
    let label

    // if (id === "std") {
    //   label =
    // }
    if (lodash.isFunction(name)) {
      label = name({ ...option })
    } else {
      label = name
    }

    return {
      label: (
        <div style={{ whiteSpace: 'nowrap' }}>
          <div>{label}</div>
          {Boolean(requiresConfirmation) && (
            <span className="text-muted">
              {' '}
              ({i18n.t('on_request', 'Auf Anfrage')})
            </span>
          )}
          {/* {/localhost/.test(window.location.href) && (
            <>
              |
              <code>
                {moment(from).format('DD.MM HH:mm')} -{' '}
                {moment(until).format('DD.MM HH:mm')}
              </code>
            </>
          )} */}
        </div>
      ),
      value: id,
      description,
    }
  })

  // console.log("timeOptions", {
  //   timeOptions,
  //   options,
  //   productTimeOptions: product.timeOptions
  // })

  return (
    <>
      <TimeHandler timeOptions={timeOptions} />
      <Wrapper className="mt-1 mr-4">
        <h6 className="mt-0">
          {isPickup
            ? i18n.t('header_pickup', 'Abholung')
            : i18n.t('header_delivery', 'Zustellung')}
        </h6>
        {/* {isPickup && (
        <div>
          {isSelfPickup ? "Anliefer./Abhol. von" : "Abholung von"}{" "}
          <strong>{moment(pickupFromTime).format("HH:mm")}</strong>
        </div>
      )}
      {!isPickup && (
        <div>
          {isSelfDelivery ? "Bereitstellung von" : "Zustellung von"}{" "}
          <strong>{moment(deliveryFromTime).format("HH:mm")}</strong>
        </div>
      )}
      <hr /> */}
        {lodash.isEmpty(options) ? (
          <div className="text-danger">
            <Icon icon="fas fa-exclamation-triangle" />{' '}
            {i18n.t(
              'sla_missing_timeoption_text',
              'Bitte wenden Sie sich an Ihren Administrator, da bei diesem Produkt eine Fehlkonfiguration vorliegt.',
            )}
          </div>
        ) : (
          <Field name="selectedTime">
            <RadioSelect options={options} />
          </Field>
        )}
        {/* {error && (
          <strong className="text-danger">Bitte eine Option auswählen</strong>
        )} */}
      </Wrapper>
    </>
  )
}

export default TimeBlock
